import { CanDeactivateFn } from '@angular/router';

/** Implemented by {@link PlanSessionPage} for router leave prompts. */
export interface PlanSessionCanDeactivate {
  confirmLeaveSession(): boolean | Promise<boolean>;
}

export const planSessionCanDeactivateGuard: CanDeactivateFn<
  PlanSessionCanDeactivate
> = (component) => component.confirmLeaveSession();
